export default __webpack_public_path__ + "static/media/Honored Belt of the Far Horizon.0fd764af.jpg";